import React, { useEffect, useState, useRef } from 'react';
import Typography from '@mui/material/Typography';
import TextField from "@mui/material/TextField";

import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import DoneIcon from '@mui/icons-material/Done';
import { useMediaQuery } from 'react-responsive';
import Grid from '@mui/material/Grid';
import LoupeItemHeaderComponent from './LoupeItemHeaderComponent';

import { LocalizationContext } from '../../App';



const LoupeChipComponent = props => {

    const isMobileView = useMediaQuery({
        query: '(max-width: 900px)'
    })

    const callbackHandler = props.callbackHandler;
    const currentItem = props.currentItem;

    const [ chipValues ] = useState(currentItem.selectedValues);

    const isInResultset = value => {
        return chipValues.includes(value);
    }
    const [ showOtherField, setShowOtherField ] = React.useState(isInResultset("other"));

    const [state, updateState] = React.useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);




    const handleChipClick = (value, item) => {
        
        currentItem.validator.touched();
        if(isInResultset(value)) {
            var idx = chipValues.indexOf(value);
            chipValues.splice(idx, 1);
        } else {
            chipValues.push(value);
        }

        if(currentItem.validator.instantRevalidation) {
            currentItem.validator.revalidate();
        }

        forceUpdate();
    }

    
    const updateOtherContentValue = (value) => {
        setOtherTextValue(value);
        currentItem.otherValue = value;  
    }


    const [ otherTextValue, setOtherTextValue ] = useState( currentItem.otherValue );
    const handleOtherTextValueChange = event => {
          updateOtherContentValue(event.target.value);            
    }
   


    return (

        <LocalizationContext.Consumer>
            { ({strings}) => 

            <div className="text-start mb-4">

                <LoupeItemHeaderComponent currentItem={currentItem} />

                <div>

                    <Grid container>

                        <Grid item xs={12} className="mb-5">
                            
                            { currentItem.choices.map(c => {
                                
                                const variant = (isInResultset(c['_attributes']['export-label'])) ? 'filled' : 'filled';
                                
                                return(
                                    <Chip 
                                        style={{margin : '3px'}}
                                        onClick={(e) => handleChipClick(c['_attributes']['export-label'], e)}
                                        value={c['_attributes']['export-label']} 
                                        {...( isInResultset(c['_attributes']['export-label']) ? { color : 'primary'} : {})}
                                        variant={variant}
                                        key={c['_attributes']['export-label']} 
                                        label={c['_attributes']['label']}/>
                                )
                            }) }

                            { currentItem.enableOtherValueField == "true" &&

                                <Chip
                                    style={{margin : '3px'}}                            
                                    value={'Other'} 
                                    onClick={(e) => { handleChipClick("other", e); setShowOtherField( isInResultset("other") ? true : false ); isInResultset("other") == false && updateOtherContentValue(""); } }
                                    {...( isInResultset("other") ? { color : 'primary'} : {})}
                                    variant={'filled'}
                                    key={'chip_other'} 
                                    label={strings.getString("texts.items.other")}/>
                            }
                            
                        </Grid>   

                        { showOtherField == true &&
                            <>
                                <Grid item xs={12}/>
                                <Grid item xs={12}>
                                    <TextField 
                                        id={currentItem.id + "_otherField"} 
                                        fullWidth                                                     
                                        label={strings.getString("messages.items.other")} 
                                        sx={{ border: 'red' }} 
                                        variant="outlined"       
                                        value={otherTextValue}                                                                                                                                                                                                     
                                        onChange={handleOtherTextValueChange}
                                        /> 
                                </Grid> 
                            </>

                        }
                        
                    </Grid>   
                        
                </div>

            </div>
        }
        </LocalizationContext.Consumer>
    );

}
export default LoupeChipComponent;